module.exports = __webpack_public_path__ + "static/media/3.dc0a1b48.jpg";